import React from 'react';
import { Skeleton, TableBody, TableCell, TableContainer, TableRow, Paper, Table } from '@mui/material';

const TableSkeleton = ({ row= 5, cols = 5, type=null }) => {
  const renderSkeletonRow = () => {
    return (
      <TableRow>
        {[...Array(cols)].map((_, index) => (
          <TableCell key={index}>
            <Skeleton animation="wave" />
          </TableCell>
        ))}
      </TableRow>
    );
  };

  const renderSkeletonRows = () => {
    return [...Array(row)].map((_, index) => (
      <React.Fragment key={index}>{renderSkeletonRow()}</React.Fragment>
    ));
  };
if(type == 'body'){
    return <TableBody>{renderSkeletonRows()}</TableBody>
} else{
  return (
    <TableContainer component={Paper}>
      <Table size='small'>
        <TableBody>{renderSkeletonRows()}</TableBody>
      </Table>
    </TableContainer>
  );}
};

export default TableSkeleton;
